<template>
  <div class="youcecd" :class="{ 'menu-collapsed': menuCollapsed }">
    <!-- 移动端折叠/展开按钮 -->
    <div class="menu-toggle" @click="menuCollapsed = !menuCollapsed">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#333">
        <path v-if="menuCollapsed" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
        <path v-else d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
      </svg>
    </div>
    <div class="menu-items-wrapper">
      <div v-for="(item, index) in menuList" :key="index + item.lfag" :class="item.lfag" @click="$emit('select', index)">
        <div class="text">{{ item.name }}</div>
        <div class="icon">
          <img :src="require('@/views/imgBUT/' + item.name + (item.lfag == 'item' ? '.png' : '_hover.png'))" alt="" />
        </div>
      </div>
    </div>
    <!-- 机场图层按钮 -->
    <div class="fixed-action-btn" :class="airportVisible ? 'itembgc1' : 'item'" @click="$emit('toggle-airport')">
      <div class="text">机场图层</div>
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
          :fill="airportVisible ? '#fff' : '#333'">
          <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
      </div>
    </div>
    <!-- 截图按钮 -->
    <div class="fixed-action-btn item" @click="$emit('screenshot')">
      <div class="text">截图保存</div>
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
      </div>
    </div>
    <!-- 联系我们 -->
    <div style="display: flex;justify-content: flex-end;margin-top: 10vh;">
      <el-tooltip placement="left" effect="dark" trigger="click">
        <template #content>
          <div style="font-size:13px; line-height:1.6;">
            需求完善请联系<br />宋先生：15044085630
          </div>
        </template>
        <div style="width: 1rem;padding: 5px;background-color: white;border-radius: 5px;cursor: pointer;line-height: 1;">
          <img src="@/assets/headphone.png" style="width: 1rem;" /><span style="font-size: 0.9rem;">联系我们</span>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  menuList: { type: Array, required: true },
  airportVisible: { type: Boolean, default: true }
});

defineEmits(['select', 'toggle-airport', 'screenshot']);

const menuCollapsed = ref(true);
</script>

<style lang="less" scoped>
.youcecd {
  position: fixed;
  right: 15px;
  top: 90px;
  z-index: 3017;
  text-align: right;

  .menu-toggle {
    display: none;
  }

  .menu-items-wrapper+.fixed-action-btn {
    margin-top: 120px;
  }

  .item {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .icon {
      width: 32px;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      border-radius: 50%;
      background-color: #fff;
      margin: 6px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img { margin: 5px; }
    }

    .text {
      margin: 10px -20px 13px 0;
      padding: 0px 30px 0px 10px;
      line-height: 24px;
      border-radius: 20px;
      font-size: 13px;
      color: #fff;
      background-color: #0b0f3960;
    }
  }

  .itembgc1 {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .icon {
      width: 32px;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      border-radius: 50%;
      background-color: #2e6eff;
      margin: 6px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img { margin: 5px; }
    }

    .text {
      margin: 10px -20px 13px 0;
      padding: 0px 30px 0px 10px;
      line-height: 24px;
      border-radius: 20px;
      font-size: 13px;
      color: #fff;
      background-color: #0b0f39;
    }
  }

  .item:hover {
    .icon {
      background-color: #2e6eff;
    }
    .text {
      background-color: #0b0f39;
    }
  }
}

@media screen and (max-width: 768px) {
  .youcecd {
    right: 6px;
    top: 60px;

    .menu-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: #fff;
      margin-left: auto;
      margin-bottom: 4px;
      cursor: pointer;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
      transition: background-color 0.2s;

      &:active {
        background-color: #2e6eff;
      }
    }

    &.menu-collapsed .menu-items-wrapper {
      display: none;
    }

    .menu-items-wrapper {
      max-height: calc(100vh - 280px);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }

    .item,
    .itembgc1 {
      .text { display: none; }
      .icon {
        width: 36px;
        height: 36px;
        line-height: 36px;
        margin: 4px 0;

        img {
          width: 22px;
          height: 22px;
          margin: 0;
          object-fit: contain;
        }
      }
    }

    .item:hover .text { display: none; }

    .menu-items-wrapper+.fixed-action-btn {
      margin-top: 60px;
    }
  }
}
</style>
